// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5aa46ad7","703":"80e6a4f6","787":"ad15ad80"}[chunkId] + ".chunk.js";
};